import reactSelectWithOptions from 'ui/form-elements/ReactSelectHOC';

export const CANDIDATE_RATING_OPTIONS = [
   {
      value: '3',
      label: 'Unrated',
   }, {
      value: '1',
      label: 'Interested',
   }, {
      value: '2',
      label: 'Unsure',
   }, {
      value: '-1',
      label: 'Not Interested',
   }];

export default reactSelectWithOptions(CANDIDATE_RATING_OPTIONS);
